// eslint-disable-next-line import/no-unresolved
import KeenSlider from './keen-slider-with-wheel.js'

const KEEN_ATTRS = ['data-keen-slider-v', 'data-keen-slider-moves']
const SLIDE_STYLE_PROPS = [
  'transform',
  '-webkit-transform',
  'min-width',
  'max-width',
  'min-height',
  'max-height',
  'width',
]

if (!customElements.get('pdp-spec-blocks')) {
  customElements.define(
    'pdp-spec-blocks',
    class PdpSpecBlocks extends window.BAO.CustomElement {
      constructor() {
        super()

        this.mq = window.matchMedia('(min-width: 901px)')
        this.carousel = null
        this.resizeTimer = 0
        this.syncCarouselState = this.syncCarouselState.bind(this)
        this.handleResize = this.handleResize.bind(this)
        this.resizeObserver = new ResizeObserver(() => this.carousel?.resize())

        this.mq.addEventListener('change', this.syncCarouselState)
        window.addEventListener('resize', this.handleResize)
        this.syncCarouselState()
      }

      disconnectedCallback() {
        super.disconnectedCallback?.()

        this.mq.removeEventListener('change', this.syncCarouselState)
        window.removeEventListener('resize', this.handleResize)
        this.resizeObserver.disconnect()
        this.destroyCarousel()
      }

      get canCarousel() {
        return this.els.slide.exists && this.els.slide.elements.length > 5
      }

      handleResize() {
        window.clearTimeout(this.resizeTimer)
        this.resizeTimer = window.setTimeout(() => {
          this.syncCarouselState()
        }, 100)
      }

      syncCarouselState() {
        const shouldCarousel = this.mq.matches && this.canCarousel

        if (shouldCarousel) {
          if (!this.carousel) {
            this.carousel = this.initialiseCarousel()
            this.resizeObserver.observe(this.els.slides.element)
          } else {
            this.carousel.resize()
            this.updateFadeEdges(this.carousel)
          }
          return
        }

        this.destroyCarousel()
        this.resetStaticLayout()
      }

      destroyCarousel() {
        if (!this.carousel) return

        this.resizeObserver.disconnect()
        this.carousel.destroy()
        this.carousel = null
        this.classList.remove('prd-SpecBlocks--carousel', 'is-fade-right')
        this.els.slides.element.removeAttribute('data-custom-cursor-external-el')
        this.resetStaticLayout()
      }

      resetStaticLayout() {
        const slidesEl = this.els.slides.element

        KEEN_ATTRS.forEach((attr) => {
          slidesEl.removeAttribute(attr)
        })

        slidesEl.style.removeProperty('transform')
        slidesEl.style.removeProperty('-webkit-transform')

        this.els.slide.elements.forEach((slide) => {
          SLIDE_STYLE_PROPS.forEach((prop) => {
            slide.style.removeProperty(prop)
          })
        })
      }

      updateFadeEdges(instance) {
        const { position, progressTrack, size, widthOrHeight } = instance.details()
        const slidesPerView = instance.options().slidesPerView || 1
        const maxPosition =
          (widthOrHeight * (size - slidesPerView)) / slidesPerView
        const canScroll = size > slidesPerView && maxPosition > 1
        const atEnd =
          !canScroll || position >= maxPosition - 1 || progressTrack >= 0.99

        this.classList.toggle('is-fade-right', canScroll && !atEnd)
      }

      initialiseCarousel() {
        this.classList.add('prd-SpecBlocks--carousel')
        this.els.slides.element.setAttribute(
          'data-custom-cursor-external-el',
          'carousel',
        )

        return new KeenSlider(this.els.slides.element, {
          duration: 600,
          mode: 'free-snap',
          slidesPerView: 5.5,
          slides: '.prd-SpecBlocks_Item',
          spacing: 48,
          controls: true,
          created: (instance) => {
            this.updateFadeEdges(instance)
          },
          move: (instance) => {
            this.updateFadeEdges(instance)
          },
          slideChanged: (instance) => {
            this.updateFadeEdges(instance)
          },
        })
      }
    },
  )
}
